function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m807.5 1363.8 678.3 161.5v-1270.5l-678.3 161.5z",
  fill: "#205b97"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m1485.8 254.8 129.2 64.6v1141.3l-129.2 64.6zm-678.3 1109-678.3 161.5v-1270.5l678.3 161.5z",
  fill: "#5193ce"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m129.2 254.8-129.2 64.6v1141.3l129.2 64.6z",
  fill: "#205b97"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m979.8 1783.7 258.4-129.2v-1525.3l-258.4-129.2-79 847z",
  fill: "#5193ce"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m635.2 1783.7-258.4-129.2v-1525.3l258.4-129.2 79 847z",
  fill: "#205b97"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m635.2 0h348.1v1780.1h-348.1z",
  fill: "#2e73b7"
});

var SvgRedshift = function SvgRedshift(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1615 1783.7",
    viewBox: "0 0 1615 1783.7",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedshift, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/redshift.3bd1a0f9.svg";
export { ForwardRef as ReactComponent };